import { RepresentApiResponseType } from "@/domain/RepresentModels.ts";

export const RepresentApi = {
  getBoundaryForCoordiates: async (lat: string, lon: string) => {
    const response = await fetch(
      `https://represent.opennorth.ca/boundaries/federal-electoral-districts-2023-representation-order/?contains=${lat},${lon}`,
    );
    const data: RepresentApiResponseType =
      (await response.json()) as RepresentApiResponseType;
    return data.objects[0].external_id;
  },
};
